module.exports = __webpack_public_path__ + "10a0410ac806811c330538b629c47b40.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-account/details/account-details.html
// module id = 2007
// module chunks = 0